const Train = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="a">
          <rect
            width="24"
            height="24"
            transform="translate(-377 4012)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(377 -4012)">
        <g transform="translate(-376.805 4015.662)">
          <path
            d="M.394,288H23.217a.394.394,0,1,1,0,.787H.394a.394.394,0,1,1,0-.787Zm0,0"
            transform="translate(0 -273.833)"
          />
          <path
            d="M18.1,12.592h-.787a1.574,1.574,0,0,1-3.148,0H10.231a1.574,1.574,0,0,1-3.148,0H6.3a1.574,1.574,0,0,1-3.148,0c0-.036.007-.07.01-.105A3.649,3.649,0,0,1,0,8.543C0,3.992,6.068,0,12.986,0H23.217a.394.394,0,0,1,.394.394V12.2a.394.394,0,0,1-.394.394H21.25a1.574,1.574,0,0,1-3.148,0ZM19.676,5.9h3.148V3.148H19.676Zm3.148.787H19.676v3.542h3.148ZM18.553,11.8h.335V3.148H14.954V11.8ZM12.2,3.148a.945.945,0,0,0-.81.457L10.113,5.9h4.053V3.148Zm3.542,10.231a.787.787,0,0,0,.787-.787H14.954A.787.787,0,0,0,15.741,13.379Zm-7.083,0a.787.787,0,0,0,.787-.787H7.87A.787.787,0,0,0,8.657,13.379ZM7.535,11.8h6.632v-.787H1.742a3.928,3.928,0,0,0,2.587.787Zm-3.6.787a.787.787,0,1,0,1.574,0H4.329c-.134,0-.264-.006-.394-.013ZM1.609,5.9h3.08A3.014,3.014,0,0,0,7.325,4.345l.6-.995a.179.179,0,0,0-.008-.167c-.009-.016-.024-.035-.039-.035H4.49A9.189,9.189,0,0,0,1.609,5.9ZM12.986.787A16.6,16.6,0,0,0,5.91,2.361H7.87a.833.833,0,0,1,.72.423.964.964,0,0,1,.011.959l-.6.994A3.8,3.8,0,0,1,4.689,6.689h-3.5a4.632,4.632,0,0,0-.4,1.854,3.732,3.732,0,0,0,.354,1.7l.039-.008H14.167V6.689H9.444A.394.394,0,0,1,9.1,6.1l1.6-2.882a1.729,1.729,0,0,1,1.5-.862H22.824V.787ZM22.824,11.8v-.787H19.676V11.8Zm-3.148,1.574a.787.787,0,0,0,.787-.787H18.889A.787.787,0,0,0,19.676,13.379Zm0,0"
            transform="translate(0 0.001)"
          />
        </g>
      </g>
    </svg>
  );
};

export default Train;
